import React, { useEffect, useRef, useState } from "react";
import Spinner from "../../components/Spinner";
import toast from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { fetchUserById } from "../../services/users";
import UserProfile from "../../components/UserProfile";

const UserProfilePage = () => {
  const { userId } = useParams();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const calledRef = useRef(false);

  const { mutate } = useMutation({
    mutationFn: () => fetchUserById(userId),
    onSuccess: (data) => {
      setUserData(data);
      setLoading(false);
      toast.success("تم تحويلك لصفحة الزيون");
    },
    onError: () => {
      setLoading(false);
      toast.error("فشل فتح صفحة الزيون");
    },
  });

  useEffect(() => {
    if (!calledRef.current) {
      mutate();
      calledRef.current = true;
    }
  }, [mutate]);

  if (loading) return <Spinner />;
  if (!userData) return null;

  return <UserProfile user={userData} />;
};

export default UserProfilePage;
